import React, {Component} from 'react';
import downloadFromAppStore from "../assets/button-appstore.png";
import downloadThankfullyButton from "../assets/button-download.png";
import footerLogo from "../assets/logo-thankfully-white.png";
export default class Footer extends Component {
    render() {
        const {saveCard} = this.props;
        return (
            <footer>
                <section id="download">
                    <div className="content bg-black bg-parallax block-news-1 padding-top-50 padding-bot-90">
                        <div className="container">
                            {saveCard ?
                                <div className="col-sm-12">
                                    <h6 className="scroll-animated-from-bottom">
                                        <b>Want to save this card, send a reply, or create one yourself?</b>
                                    </h6>
                                </div> : ""}
                            <div className="header text-center scroll-animated-from-bottom">
                                <h3><strong>Get Thankfully</strong></h3>
                            </div>
                            <div className="col-sm-12">
                                <h6 className="scroll-animated-from-bottom">
                                    <b>Thankfully for iOS</b> is available in the Apple App Store.
                                </h6>
                            </div>
                            <div className="col-sm-12">
                                <center>
                                    <a href="https://itunes.apple.com/us/app/thankfully-just-say-thanks/id1329296299">
                                        <img width={140} src={downloadFromAppStore}/>
                                    </a>
                                    <br/>
                                    <br/>
                                    <br/>
                                    <a href="https://itunes.apple.com/us/app/thankfully-just-say-thanks/id1329296299">
                                        <img width={250} src={downloadThankfullyButton}/>
                                    </a>
                                    <br/>
                                    <br/>
                                </center>
                            </div>

                            <div className="col-sm-6 col-sm-offset-3 mt-30">
                                <h6 className="scroll-animated-from-bottom text-center">
                                       <b>Thankfully for Android</b> is in the works.
                                    Sign up to be notified when our Android app is available.&nbsp;&nbsp;
                                <br/>                        
                                <b>
                                    <a href="https://thankfully.us19.list-manage.com/subscribe?u=1c8aee69e8f77215449628999&id=28f5894642"
                                        style={{whiteSpace: "nowrap"}}>Notify me ></a></b>
                                </h6>
                            </div>
                            <div className="col-sm-12 text-center">
                                <img className="footer-logo" src={footerLogo} alt="<3 Thankfully"/>
                                <div className="footer-links">
                                    <a href="mailto:hello+feedback@thankfully.com">Feedback</a>
                                    <a href="mailto:hello+contact@thankfully.com">Contact Us</a>
                                </div>
                                <div className="copyright scroll-animated-from-bottom">© 2018 - All Rights Reserved.
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </footer>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js